/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Hotel_Lobby_DescriptionInputs */

const en_admin_settings_groups_hotel_lobby_description = /** @type {(inputs: Admin_Settings_Groups_Hotel_Lobby_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two photos → Nano Banana scene → MiniMax H3 Max Turbo video (uses the EvoLink key)`)
};

/**
* | output |
* | --- |
* | "Two photos → Nano Banana scene → MiniMax H3 Max Turbo video (uses the EvoLink key)" |
*
* @param {Admin_Settings_Groups_Hotel_Lobby_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_hotel_lobby_description = /** @type {((inputs?: Admin_Settings_Groups_Hotel_Lobby_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Hotel_Lobby_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_hotel_lobby_description(inputs)
});
export { admin_settings_groups_hotel_lobby_description as "admin.settings.groups.hotel_lobby.description" }